<template>
  <v-app
    :style="
      $route.name === 'ClaimCombinationResultPrint'
        ? { background: '#fff' }
        : { background: '#F4F4F4' }
    "
  >
    <v-main>
      <v-container fluid>
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import 'inticons/fonts/inticons.bundle.min.css';

export default {
  data: () => ({
    drawer: true,
  }),

  computed: {},
  watch: {
    $route(to, from) {
      if (to.name !== 'ClaimCombinationResultPrint') {
        document.querySelector('body').style.background = '#F4F4F4';
        return;
      }
      document.querySelector('body').style.background = '#fff';
    },
  },
};
</script>

<style>
/*
Copyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.
https://github.com/orioncactus/pretendard

This Font Software is licensed under the SIL Open Font License, Version 1.1.
This license is copied below, and is also available with a FAQ at:
http://scripts.sil.org/OFL
*/

@font-face {
  font-family: 'Pretendard';
  font-weight: 900;
  font-display: swap;
  src: local('Pretendard Black'),
    url('./assets/fonts/woff2-subset/Pretendard-Black.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Black.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 800;
  font-display: swap;
  src: local('Pretendard ExtraBold'),
    url('./assets/fonts/woff2-subset/Pretendard-ExtraBold.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-ExtraBold.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 700;
  font-display: swap;
  src: local('Pretendard Bold'),
    url('./assets/fonts/woff2-subset/Pretendard-Bold.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Bold.subset.woff') format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 600;
  font-display: swap;
  src: local('Pretendard SemiBold'),
    url('./assets/fonts/woff2-subset/Pretendard-SemiBold.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-SemiBold.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 500;
  font-display: swap;
  src: local('Pretendard Medium'),
    url('./assets/fonts/woff2-subset/Pretendard-Medium.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Medium.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 400;
  font-display: swap;
  src: local('Pretendard Regular'),
    url('./assets/fonts/woff2-subset/Pretendard-Regular.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Regular.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 300;
  font-display: swap;
  src: local('Pretendard Light'),
    url('./assets/fonts/woff2-subset/Pretendard-Light.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Light.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 200;
  font-display: swap;
  src: local('Pretendard ExtraLight'),
    url('./assets/fonts/woff2-subset/Pretendard-ExtraLight.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-ExtraLight.subset.woff')
      format('woff');
}

@font-face {
  font-family: 'Pretendard';
  font-weight: 100;
  font-display: swap;
  src: local('Pretendard Thin'),
    url('./assets/fonts/woff2-subset/Pretendard-Thin.subset.woff2')
      format('woff2'),
    url('./assets/fonts/woff-subset/Pretendard-Thin.subset.woff') format('woff');
}

body,
input,
select,
button,
textarea,
code,
text,
.v-application {
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto,
    'Helvetica Neue', 'Segoe UI', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
}
.v-toast__item .v-toast__icon {
  display: none !important;
}
.v-toast__item {
  padding: 0.75rem 1rem !important;
  background-color: #1a1b1e !important;
}
.v-toast__text {
  padding: 0 !important;
}
</style>
